import {
  GET_PROGRAM_CHARTDATA_REQUEST,
  GET_PROGRAM_CHARTDATA_SUCCESS,
  GET_PROGRAM_CHARTDATA_FAILED,
  GET_PRACTITIONER_DETAIL_CHART_REQUEST,
  GET_PRACTITIONER_DETAIL_CHART_SUCCESS,
  GET_PRACTITIONER_DETAIL_CHART_FAILED
  } from '../Actions/OverviewAction';
  const OverviewInitialState = {
    loading: false,
    OverviewList: [],    
    PractitionerOverview: []
  };
  export const OverviewReducer = (state = OverviewInitialState, action) => {
    switch (action.type) {
      case GET_PROGRAM_CHARTDATA_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case GET_PROGRAM_CHARTDATA_SUCCESS:
        return {
          ...state,
          OverviewList: action?.payload,          
          loading: false,
        };
      case GET_PROGRAM_CHARTDATA_FAILED:
        return {
          ...state,
          loading: false,
        };
      case GET_PRACTITIONER_DETAIL_CHART_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case GET_PRACTITIONER_DETAIL_CHART_SUCCESS:
        return {
          ...state,
          PractitionerOverview: action?.payload,          
          loading: false,
        };
      case GET_PRACTITIONER_DETAIL_CHART_FAILED:
        return {
          ...state,
          loading: false,
        };
      default:
        return state;
    }
  };
  